import React, { useContext, useState } from 'react';
import * as Yup from 'yup';
import { create } from '@app/api/template';
import { getTipoServicoOptions } from '@app/api/tipoServico';
import { hasPermission } from '@app/helpers/permissions';
import {
  Button,
  FormatText,
  FormCheckbox,
  FormInput,
  FormSelect,
  FormSubmitButton,
  MasterDetailForm,
  Row,
  Widget,
  Col,
  FormContext,
} from '@digital/ui';
import { Modal } from 'antd';

import { UploadFile } from '@app/components';
import { getDescricoesDocumentoOptions } from '@app/api/demanda';

interface PropsModal {
  onUpdate: any;
}

const ModalCreateForm = (props: PropsModal) => {
  const { onUpdate } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const [arquivo, setArquivo] = useState<boolean>(true);
  const [initialValues, setInitialValues] = useState([]);
  const { formProps } = useContext(FormContext);

  const handleSubmit = (values: any) => {
    create(values).then(data => {
      if (data.valid) {
        onUpdate();
        setInitialValues(null);
        setExibirModal(false);
        setArquivo(false);
      }
    });
  };

  return (
    <>
      <Row>
        <Button
          onClick={() => {
            setExibirModal(true);
            // CarregarDados();
          }}>
          INCLUIR TEMPLATE
        </Button>
      </Row>
      <Modal
        title="TEMPLATE"
        width="1200px"
        visible={exibirModal}
        onCancel={() => {
          setInitialValues(null);
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          validationSchema={Yup.object().shape({
            descricaoDocumento: Yup.string()
              .required('Descrição do Documento deve ser informado.')
              .max(2000, 'A descrição deve ter no máximo 2000 caracteres.'),
          })}
          initialValues={initialValues}
          key="formTemplate"
          onSubmit={handleSubmit}
          actions={[
            <Button
              type="link"
              onClick={() => {
                setInitialValues(null);
                setExibirModal(false);
              }}>
              Fechar
            </Button>,
            <FormSubmitButton noIcon type="primary" disabled={!hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR'])}>
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <Row style={{ margin: '0px' }}>
              <FormSelect
                id="mrn-select-tipoServico"
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, item) => {
                  return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                }}
                label="Tipo de Serviço"
                getOptions={getTipoServicoOptions}
                name="tipoServicoId"
                span={6}
              />
              <FormSelect
                showSearch
                optionFilterProp="children"
                filterOption={(input, item) => {
                  return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                }}
                label="Descrição Documento"
                getOptions={getDescricoesDocumentoOptions}
                name="descricaoDocumento"
                span={6}
              />
            </Row>
            <Row style={{ margin: '0px' }}>
              <UploadFile nameFormData={'arquivo'} label={'Arquivo Template'} hasFile={arquivo} type="primary" />
            </Row>
          </Widget>

        </MasterDetailForm>
      </Modal>
    </>
  );
};

export default ModalCreateForm;
